import { render, staticRenderFns } from "./brandbar.vue?vue&type=template&id=45232537&scoped=true&"
import script from "./brandbar.vue?vue&type=script&lang=js&"
export * from "./brandbar.vue?vue&type=script&lang=js&"
import style0 from "./brandbar.vue?vue&type=style&index=0&id=45232537&prod&lang=scss&scoped=true&"
import style1 from "./brandbar.vue?vue&type=style&index=1&id=45232537&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45232537",
  null
  
)

export default component.exports